import { render } from "./SupplierDetailAdvancedOptionsTab.vue?vue&type=template&id=2905d90e&scoped=true"
import script from "./SupplierDetailAdvancedOptionsTab.vue?vue&type=script&lang=js"
export * from "./SupplierDetailAdvancedOptionsTab.vue?vue&type=script&lang=js"

import "./SupplierDetailAdvancedOptionsTab.vue?vue&type=style&index=0&id=2905d90e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2905d90e"]])

export default __exports__